import { Directive, ElementRef, Input, OnInit, OnChanges, SimpleChanges, HostListener } from '@angular/core';

@Directive({
	selector: '[round]'
})
export class RoundDirective implements OnInit, OnChanges {
	@Input() round: number = 0; // 指令名同时作为参数，接收小数位数
	private originalValue: string | null = null;

	constructor(private el: ElementRef) { }

	ngOnInit(): void {
		this.processContent();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['round']) {
			this.processContent();
		}
	}

	// 监听输入框变化（如果用于输入框）
	@HostListener('input') onInput(): void {
		this.originalValue = null; // 重置原始值
		this.processContent();
	}

	private processContent(): void {
		const element = this.el.nativeElement;
		const content = element.textContent?.trim() || (element.value?.trim() || '');

		if (!content || isNaN(Number(content))) return;

		// 保存原始值（只保存一次，避免重复处理导致精度问题）
		if (this.originalValue === null) {
			this.originalValue = content;
		}

		// 1. 四舍五入到指定小数位数
		const numberValue = parseFloat(this.originalValue);
		const decimalPlaces = Math.max(0, Math.floor(Number(this.round))); // 确保是非负整数
		const roundedValue = Number(numberValue.toFixed(decimalPlaces));

		// 2. 移除尾部无效的0和小数点
		// 例如：4.50 → "4.5"，3.0 → "3"，5.14 → "5.14"
		const formattedValue = this.removeTrailingZeros(roundedValue.toString());

		// 3. 更新显示
		if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
			element.value = formattedValue;
		} else {
			element.textContent = formattedValue;
		}
	}

	// 核心方法：移除尾部无效的0和小数点
	private removeTrailingZeros(numStr: string): string {
		// 如果包含小数点
		if (numStr.includes('.')) {
			// 移除尾部的0，再移除可能残留的小数点（如"4." → "4"）
			return numStr.replace(/\.0+$/, '').replace(/(\.\d*?[1-9])0+$/, '$1');
		}
		return numStr; // 整数直接返回
	}
}